import { savedOrderListHeaderStyles } from "@insite/content-library/Widgets/SavedOrderList/SavedOrderListHeader";
import Filter from "@insite/mobius/Icons/Filter";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

savedOrderListHeaderStyles.toggleFilterButton = {
    color: "transparent",
    shadow: false,
    css: css`
        width: 40px;
        padding: 0;
    `,
};

savedOrderListHeaderStyles.toggleFilterButtonIcon = {
    src: Filter,
    size: 24,
    css: css`
        color: ${getColor("primary")} !important;
    `,
};
